import { useContext } from 'react';
import { AgencyContext } from '../../App';
import { Agency } from '../../types/Agency';

type AgencyContextState = Agency | null;

const useAgencyContext = (): AgencyContextState => {
    // Collapse the loading (`undefined`) state to `null` so consumers only deal with Agency | null.
    return useContext(AgencyContext) ?? null;
};

export type { AgencyContext };
export type { AgencyContextState };
export { useAgencyContext };
